// @ts-nocheck
export function createTranscriptBatcher({
  post,
  getMeta,
  flushIntervalMs = 5000,
  maxBatch = 10,
  log = () => {},
} = {}) {
  let queue = [];
  let timer = null;
  let sending = false;
  let inFlight = Promise.resolve();

  function schedule() {
    if (timer) return;
    timer = setInterval(() => {
      flush();
    }, flushIntervalMs);
  }

  function doSend() {
    const meta = (getMeta && getMeta()) || {};
    if (!meta.callSid || queue.length === 0) return Promise.resolve();
    const batch = queue.splice(0, queue.length);
    let result;
    try {
      result = post({
        callSid: meta.callSid,
        traceId: meta.traceId || null,
        provider: meta.provider || "browser_speech",
        language: meta.language || "en-IN",
        lines: batch,
      });
    } catch (e) {
      queue = batch.concat(queue); // requeue for retry
      log("sync-failed", e);
      return Promise.resolve();
    }
    return result.then(
      () => {},
      (e) => {
        queue = batch.concat(queue); // requeue for retry
        log("sync-failed", e);
      }
    );
  }

  function flush() {
    try {
      if (sending) return inFlight; // a send is already in progress
      if (queue.length === 0) return Promise.resolve();
      const meta = (getMeta && getMeta()) || {};
      if (!meta.callSid) return Promise.resolve(); // nothing to key to yet
      sending = true;
      inFlight = doSend().then(() => {
        sending = false;
      });
      return inFlight;
    } catch (e) {
      sending = false;
      log("sync-failed", e);
      return Promise.resolve();
    }
  }

  function add(line) {
    queue.push(line);
    schedule();
    if (queue.length >= maxBatch) flush();
  }

  function stopAndFlush() {
    if (timer) {
      clearInterval(timer);
      timer = null;
    }
    // Wait for any in-flight send, then drain whatever remains (lines queued
    // while that send was in progress) so the final batch isn't lost.
    return inFlight.then(() => flush());
  }

  return { add, flush, stopAndFlush, queueSize: () => queue.length };
}
